import type { NavigationGuard } from 'vue-router'

export const rolesGuard: NavigationGuard = async (to, _from, next) => {
  const authStore = useAuthStore()

  if (authStore.user && to.meta.allowedRole && authStore.user.role !== to.meta.allowedRole) {
    return next(authService.getDefaultRoleRoute())
  }

  next()
}
